module.exports = "<div class=\"copyright\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p style=\"text-align:center;\">\r\n          All Content Copyright &copy;2019, Milestone Project Services LLC. All Rights Reserved.\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/footer/footer.component.html
// module id = ./src/app/components/framework/footer/footer.component.html
// module chunks = main